import "./styles.css";
import { bootCrypto } from "./app/session.js";
import { App } from "./ui/app.js";

async function boot(): Promise<void> {
  const root = document.getElementById("app");
  if (!root) return;
  try {
    await bootCrypto(); // load the libsodium WASM before anything touches a key
  } catch {
    root.textContent = "Couldn't load the secure components. Please reload.";
    return;
  }
  root.classList.remove("boot");
  await new App(root).start();
}

void boot();
